import {ReferenceInput, required, SelectInput} from "react-admin";
import React from "react";

const StationChooser = (props) => {
    return (
        <ReferenceInput
            label="Station"
            source="stationId"
            reference="station"
            variant='outlined'
            validate={required()}
            fullWidth={props.fullWidth}
        >
            <SelectInput
                helperText={props.helperText ? props.helperText : "Choose a station"}
                optionText={(record) => {
                    return record.id
                }}
            />
        </ReferenceInput>);
}

export default StationChooser;